import { IAccount, Role, RoleType } from '@src/app/types';
import { api } from '.';
import { ITokenResponse } from '../authentication/types';

interface IAccountApiModel {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  roles: RoleType[];
  businesses: { id: string }[];
}

export interface IUpdateAccountRequest {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  roles: RoleType[];
  gender: string;
}

export interface IUpdateUserAccountRequest {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
}

export interface IUpdatePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

// Define a service using a base URL and expected endpoints
export const accountApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAccountInfo: builder.query<IAccount, ITokenResponse>({
      query: () => ({ url: '/customer/me', method: 'get' }),
      providesTags: ['account'],
      transformResponse: (response: IAccountApiModel) => {
        const roles: Role[] = [];
        response.roles.forEach((r) => roles.push(r.name));
        const result: IAccount = {
          id: response.id,
          firstName: response.firstName,
          lastName: response.lastName,
          email: response.email,
          phoneNumber: response.phoneNumber,
          roles,
          businessId: response.businesses?.at(0)?.id ?? '',
        };

        return result;
      },
    }),
    updateUserAccountDetails: builder.mutation<void, IUpdateUserAccountRequest>(
      {
        query: ({ id, ...data }) => {
          return {
            url: `/customer/account/${id}`,
            method: 'PUT',
            data,
          };
        },
        invalidatesTags: ['account'],
      }
    ),
    updateAccountPassword: builder.mutation<void, IUpdatePasswordRequest>({
      query: ({ ...data }) => {
        return {
          url: `/customer/account/password/me`,
          method: 'PUT',
          data,
        };
      },
      invalidatesTags: ['account'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAccountInfoQuery,
  useUpdateUserAccountDetailsMutation,
  useUpdateAccountPasswordMutation,
} = accountApi;
